<icon-position colorName="red" [hasDeniedGpsAccess]="hasDeniedGpsAccess$ | async"></icon-position>
